import { gql } from "@apollo/client";

export const rolesFragment = gql`
    fragment MyLensesRoles on MyLensesGetRolesResponse {
        rolesList {
            id
            containerKind
            containerId
            roleType
        }
    }
`;
